exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden-input-field[data-v-228b9b28]{position:absolute;left:-1000px;top:-10px}.text-red[data-v-228b9b28]{color:red}.readonly-dropdown[data-v-228b9b28]{background-color:#e9ecef!important;opacity:1!important}", ""]);

// exports
